export const supportedMedia =
  "https://prismic.io/docs/guides/manage-images#supported-media"
